<div class="loader">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="spinner">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
          </div>
      </div>
  </div>
</div>
